'use strict';

var API_METHODS = {
    GET: "GET",
    POST: "POST",
    DELETE: "DELETE",
};

exports.API_METHODS = API_METHODS;
//# sourceMappingURL=Api.constants.js.map
